// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_k2-0";